// extracted by mini-css-extract-plugin
export default {"main":"HospitalFilter_main__lxOBk","sub":"HospitalFilter_sub__cR1kD","btn":"HospitalFilter_btn__lBCgd","input":"HospitalFilter_input__rHalD"};